import { Navigate, RouteObject } from "react-router-dom";
import UnauthLayout from "./components/layouts/UnauthLayout";
import AppsPage from "./components/pages/AppsPage";
import AccountPage from "./components/pages/AccountPage";
import SettingsPage from "./components/pages/SettingsPage";
import UsersPage from "./components/pages/UsersPage";
import SetupPage from "./components/pages/SetupPage";
import CompaniesPage from "./components/pages/CompaniesPage";
import NewCompanyPage from "./components/pages/NewCompanyPage";
import DownloadPage from "./components/pages/DownloadPage";
import SecurityHubPage from "./components/pages/SecurityHubPage";
import EmailFirstLogin from "./components/views/Login";
import AuthLayout from "./components/layouts/AuthLayout";
import SmsTermsPage from "./components/pages/SmsTermsPage";
import PrivacyPolicyPage from "./components/pages/PrivacyPolicyPage";
import LogoutRedirectPage from "./components/pages/LogoutRedirectPage";
import LoginRedirectPage from "./components/pages/LoginRedirectPage";
import { Authenticator } from "@aws-amplify/ui-react";
import AuthView from "./components/views/AuthView";
import { ThemeProvider as AmplifyThemeProvider } from "@aws-amplify/ui-react";
import amplifyTheme from "./amplifyTheme";
import InvitePage from "./components/pages/InvitePage";
import PageNotFound from "./components/pages/PageNotFound";

const routes = (): RouteObject[] => [
  {
    path: "/auth",
    element: <UnauthLayout />,
    children: [
      {
        path: "login",
        element: (
          <AmplifyThemeProvider theme={amplifyTheme}>
            <EmailFirstLogin />
          </AmplifyThemeProvider>
        ),
      },
      {
        path: "redirect",
        element: <LogoutRedirectPage />,
      },
      {
        path: "code",
        element: <LoginRedirectPage />,
      },
      {
        path: "",
        element: <Navigate to="/auth/login" replace={true} />,
      },
      {
        path: "*",
        element: <Navigate to="/auth/login" replace={true} />,
      },
    ],
  },
  {
    path: "",
    element: <UnauthLayout />,
    children: [
      {
        path: "terms",
        element: <SmsTermsPage />,
      },
      {
        path: "privacy",
        element: <PrivacyPolicyPage />,
      },
      {
        path: "invite",
        element: <InvitePage />,
      },
      { path: "", element: <Navigate to="/apps" /> },
      { path: "*", element: <PageNotFound /> },
    ],
  },
  {
    path: "",
    element: (
      <Authenticator.Provider>
        <AuthView>
          <AuthLayout />
        </AuthView>
      </Authenticator.Provider>
    ),
    children: [
      {
        path: "login",
        element: <></>,
      },
      {
        path: "account",
        element: <AccountPage />,
      },
      {
        path: "apps",
        element: <AppsPage />,
      },
      {
        path: "select",
        element: <CompaniesPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "start",
        element: <></>,
      },
      {
        path: "users",
        element: <UsersPage />,
      },
      {
        path: "users/:id",
        element: <UsersPage />,
      },
      {
        path: "setup",
        element: <SetupPage />,
      },
      {
        path: "new",
        element: <NewCompanyPage />,
      },
      {
        path: "download",
        element: <DownloadPage />,
      },
      {
        path: "security",
        element: <SecurityHubPage />,
      },
      { path: "", element: <Navigate to="/apps" /> },
      { path: "*", element: <PageNotFound /> },
    ],
  },
  {
    path: "/app",
    element: (
      <Authenticator.Provider>
        <AuthView>
          <AuthLayout />
        </AuthView>
      </Authenticator.Provider>
    ),
    children: [
      {
        path: "*",
        element: <></>,
      },
    ],
  },
];

export default routes;
